import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Search } from 'lucide-react';
import { Input } from '../ui/input';
import { VerdictBadge, verdictKey } from './Verdict';

const FILTERS = [['all', 'All'], ['high_risk', 'High Risk'], ['review', 'Review'], ['clean', 'Clean'], ['running', 'Scanning']];
const SOURCE = { manual: 'Quick check', candidate: 'Candidate', bulk: 'Bulk', auto: 'Auto' };
const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

export const ScansTable = ({ scans, filter, onFilter, q, onSearch }) => {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl border bg-card overflow-hidden" data-testid="scout-scans-table">
      <div className="flex flex-wrap items-center gap-2 p-3 border-b">
        {FILTERS.map(([k, label]) => (
          <button key={k} onClick={() => onFilter(k)} data-testid={`scout-filter-${k}`}
            className={`text-xs font-semibold px-3 py-1.5 rounded-full transition-colors ${filter === k ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:text-foreground'}`}>
            {label}
          </button>
        ))}
        <div className="relative ml-auto w-full sm:w-64">
          <Search className="h-3.5 w-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => onSearch(e.target.value)} placeholder="Search name, email, phone" className="pl-8 h-9" data-testid="scout-search-input" />
        </div>
      </div>
      <div className="divide-y">
        {scans.map((s) => (
          <button key={s.id} onClick={() => navigate(`/scout/${s.id}`)} data-testid={`scout-scan-row-${s.id}`}
            className="w-full text-left flex items-center gap-4 px-4 py-3 hover:bg-muted/40 transition-colors group">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{s.name}</p>
              <p className="text-xs text-muted-foreground truncate">{[s.email, s.phone].filter(Boolean).join(' · ') || s.linkedin_url}</p>
              {s.issues?.length > 0 && <p className="text-xs mt-1 truncate text-foreground/70">{s.issues[0]}{s.issue_count > 1 ? ` (+${s.issue_count - 1} more)` : ''}</p>}
            </div>
            <div className="hidden md:block text-right text-[11px] text-muted-foreground w-36 shrink-0">
              <p>{SOURCE[s.source] || s.source}{s.vendor ? ` · ${s.vendor}` : ''}</p>
              <p>{when(s.created_at)}</p>
            </div>
            <div className="w-32 flex justify-end shrink-0">
              <VerdictBadge verdict={verdictKey(s)} score={s.trust_score} testid={`scout-row-verdict-${s.id}`} />
            </div>
            {s.override && <span className="hidden lg:inline text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Overridden</span>}
            <ChevronRight className="h-4 w-4 text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
          </button>
        ))}
        {!scans.length && <p className="text-center text-sm text-muted-foreground py-16" data-testid="scout-scans-empty">No scans yet — run a quick check or upload a CSV.</p>}
      </div>
    </div>
  );
};

export default ScansTable;
